// extracted by mini-css-extract-plugin
export default {"mainContent":"Dogovir_mainContent__R0oJc","p":"Dogovir_p__Pye66"};